/** @format */

import React from 'react';
import cn from 'classnames';
import s from './Divider.module.scss';
import { Typography } from '../Typography';

type DividerProps = {
  className?: string;
  style?: React.CSSProperties;
  variant:
    | 'padded'
    | 'full'
    | 'dotted'
    | 'dashed'
    | 'or'
    | 'and'
    | 'empty'
    | 'decorative1'
    | 'largeDashed';
};

export function Divider(props: DividerProps) {
  const { variant, className, style } = props;

  const classNames = cn({ [s[variant]]: true, [className]: !!className });

  if (variant === 'or') {
    return (
      <div className={classNames} style={style}>
        <Typography label="OR" variant="body_2_medium" color="primary" />
      </div>
    );
  }

  if (variant === 'and') {
    return (
      <div className={classNames} style={style}>
        <Typography label="AND" variant="tiny_extended_medium" color="tertiary" />
      </div>
    );
  }

  if (variant === 'decorative1') {
    return (
      <div className={classNames} style={style}>
        <div className={s.small_dot}></div>
        <div className={s.big_dot}></div>
        <div className={s.small_dot}></div>
      </div>
    );
  }

  return <hr className={cn(classNames, s.hr)} style={style} />;
}
